// extracted by mini-css-extract-plugin
export default {"overlay":"style_overlay__UTeAt","loader":"style_loader__JoD76"};